import { agentsApi } from '../../agents-api.ts';
import type { ProjectInfo } from '../../agents-api.ts';
import { field, openDialog, toast } from '../../components.ts';
import { h } from '../../ui.ts';

/** "New agent": a task for a new agent on its own branch of a project (POST /projects/:slug/agents). */
export function newAgentDialog(projects: ProjectInfo[], preset?: string) {
  const own = projects.filter((p) => !p.linearOrg);
  const select = h(
    'select',
    { class: 'input', name: 'project' },
    ...own.map((p) => h('option', { value: p.slug, ...(p.slug === preset ? { selected: true } : {}) }, p.name)),
  );
  const title = h('input', { class: 'input', name: 'title', placeholder: 'Pricing page', maxlength: '80' });
  const task = h('textarea', {
    class: 'textarea',
    name: 'task',
    required: true,
    rows: '5',
    placeholder: 'Add a pricing page with three plans and a FAQ. Keep the current header.',
  });
  const body = [
    h('p', {}, 'It works on its own branch and starts a preview when there is something to see.'),
    preset ? null : field('Project', select),
    field('Task', task, 'In your words; the agent asks if something is unclear.'),
    field('Title', title, 'Optional. A few words for lists and speech.'),
  ].filter((x): x is HTMLElement => x !== null);
  openDialog('New agent', body, {
    label: 'Start agent',
    run: async () => {
      const text = task.value.trim();
      if (!text) {
        task.focus();
        return false;
      }
      const a = await agentsApi.start(preset ?? select.value, text, title.value.trim() || undefined);
      toast(`Started “${a.title}”`);
      location.hash = `#/agent/${encodeURIComponent(a.id)}`;
      return true;
    },
  });
  setTimeout(() => task.focus(), 0);
}
